<template>
  <el-dialog
    :visible="isVisible"
    width="90%"
    title="Delivery Rules"
    @close="$emit('close')"
  >
    <div>
      <p class="break-word">
        There are different minimum order amount requirements depending on
        delivery distance, illustrated as follows:
      </p>
      <el-row :gutter="20">
        <el-col :span="12"><strong>Distance</strong></el-col>
        <el-col :span="12"><strong>Minimum Amount</strong></el-col>
      </el-row>

      <el-row
        :gutter="20"
        v-for="deliveryRule of MINIMUM_DELIVERY_AMOUNT_MATRIX"
        :key="deliveryRule.minimumAmount"
      >
        <el-col :span="12">
          <span v-if="deliveryRule.distance.min === 0">
            &leq; {{ (deliveryRule.distance.max / 1000).toFixed(0) }}km
          </span>
          <span v-if="deliveryRule.distance.max === Number.MAX_SAFE_INTEGER">
            &gt; {{ (deliveryRule.distance.min / 1000).toFixed(0) }}km
          </span>
          <span
            v-if="
              deliveryRule.distance.min > 0 &&
              deliveryRule.distance.max < Number.MAX_SAFE_INTEGER
            "
          >
            {{ (deliveryRule.distance.min / 1000).toFixed(0) }}-{{
              (deliveryRule.distance.max / 1000).toFixed(0)
            }}km
          </span>
        </el-col>
        <el-col :span="12">${{ deliveryRule.minimumAmount }}</el-col>
      </el-row>
      <p class="break-word">
        There is no delivery fee charged when distance is &leq;
        {{ FREE_DELIVERY_MAX_DISTANCE }}. {{ UNIT_DELIVERY_FEE }} delivery fee
        per km is charged when distance exceeds
        {{ FREE_DELIVERY_MAX_DISTANCE }}.
      </p>
    </div>
  </el-dialog>
</template>

<script>
import {
  FREE_DELIVERY_MAX_DISTANCE,
  UNIT_DELIVERY_FEE,
  MINIMUM_DELIVERY_AMOUNT_MATRIX,
} from "@/utils/order";

export default {
  name: "delivery-rule-dialog",
  props: {
    isVisible: Boolean,
  },
  data() {
    return {
      FREE_DELIVERY_MAX_DISTANCE,
      UNIT_DELIVERY_FEE,
      MINIMUM_DELIVERY_AMOUNT_MATRIX,
    };
  },
};
</script>

<style scoped>
</style>